<!-- This live game data from adaptive_components: get_scoreboard-->
<template>
  <div class="sidearm-mm-run-game__game py-5">
    <div class="sidearm-mm-run-game__header w-100 bg-white flex">
      <div
        class="sidearm-mm-run-game__round border-light-a type-heading-bracket-plain  flex flex-justify-center flex-align-center"
      >
        Rd. {{ round.round }}
      </div>
      <div
        class="sidearm-mm-run-game__team relative pa-2 border-light-y flex flex-align-center flex-justify-center"
      >
        <div
          v-if="has_both_seeds"
          class="sidearm-mm-run-game__team-seed type-hero-small-plain mr-1"
        >
          #{{
            game.location_indicator === "A"
              ? $root.data.team.seed
              : game.opponent.seed
          }}
        </div>
        <div class="sidearm-mm-run-game__team-logo-container py-2">
          <div class="sidearm-mm-run-game__team-logo">
            <img
              v-if="game.location_indicator === 'A'"
              :src="$root.school_logo(96, 96)"
              :alt="
                $root.data.school.name ? $root.data.school.name : 'School Logo'
              "
            />
            <img
              v-else
              :src="
                game.opponent && game.opponent.image && game.opponent.image.url
                  ? `${$root.absolutize_cdn(
                      game.opponent.image.url
                    )}?width=96&height=96`
                  : `${$root.school_logo(96, 96)}&s.grayscale=100`
              "
              :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
            />
          </div>
        </div>
      </div>
      <div
        v-if="game.result"
        class="sidearm-mm-run-game__result border-light-a flex flex-align-center "
      >
        <div
          class="sidearm-mm-run-game__score sidearm-mm-run-game__score--left col-4-of-8 flex flex-align-center flex-justify-center"
          :class="
            (game.location_indicator === 'A' && game.result.status === 'W') ||
            (game.location_indicator !== 'A' && game.result.status !== 'W')
              ? 'sidearm-mm-run-game__score--winner'
              : ''
          "
        >
          <span class="type-hero-small text-center">{{
            game.location_indicator === "A"
              ? game.result.team_score
              : game.result.opponent_score
          }}</span>
        </div>
        <div
          class="sidearm-mm-run-game__score sidearm-mm-run-game__score--right col-4-of-8 flex flex-align-center flex-justify-center"
          :class="
            (game.location_indicator !== 'A' && game.result.status === 'W') ||
            (game.location_indicator === 'A' && game.result.status !== 'W')
              ? 'sidearm-mm-run-game__score--winner'
              : ''
          "
        >
          <span class="type-hero-small text-center">{{
            game.location_indicator !== "A"
              ? game.result.team_score
              : game.result.opponent_score
          }}</span>
        </div>
      </div>
      <div
        class="sidearm-mm-run-game__team relative pa-2 border-light-y flex flex-align-center flex-justify-center "
      >
        <div class="sidearm-mm-run-game__team-logo-container py-2">
          <div class="sidearm-mm-run-game__team-logo">
            <img
              v-if="game.location_indicator !== 'A'"
              :src="$root.school_logo(96, 96)"
              :alt="
                $root.data.school.name ? $root.data.school.name : 'School Logo'
              "
            />
            <img
              v-else
              :src="
                game.opponent && game.opponent.image && game.opponent.image.url
                  ? `${$root.absolutize_cdn(
                      game.opponent.image.url
                    )}?width=96&height=96`
                  : `${$root.school_logo(96, 96)}&s.grayscale=100`
              "
              :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
            />
          </div>
        </div>
        <div
          v-if="has_both_seeds"
          class="sidearm-mm-run-game__team-seed ml-1 type-hero-small-plain"
        >
          #{{
            game.location_indicator !== "A"
              ? $root.data.team.seed
              : game.opponent.seed
          }}
        </div>
      </div>
      <div
        class="sidearm-mm-run-game__button-container border-light-a relative"
      >
        <button
          role="button"
          @click="toggle_accordion(!is_open)"
          class="sidearm-mm-run-game__button absolute w-100 h-100"
        >
          <icon size="48">{{
            is_open ? "sf-minus-minimal" : "sf-plus-minimal"
          }}</icon>
        </button>
      </div>
    </div>
    <transition
      name="accordion"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
    >
      <div v-show="is_open" class="sidearm-mm-run-game__body bg-white">
        <div class="sidearm-mm-run-game__body-inner w-100 border-light-a flex">
          <div
            class="sidearm-mm-run-game__postgame sidearm-mm-run-game__body-column"
          >
            <h3 class="type-heading-bracket-plain ma-0 pb-4">
              {{ round.title }}
            </h3>
            <div class="sidearm-mm-run-game__linescore">
              <div class="type-heading-small pb-2">Final</div>
              <table
                v-if="line_scores"
                class="sidearm-mm-run-game__linescore-table text-center type-paragraph-small w-100"
                cellspacing="0"
              >
                <caption class="hide">
                  Score by Periods
                </caption>
                <tbody>
                  <tr>
                    <th scope="row" class="text-normal">
                      <div
                        :class="{
                          'sidearm-mm-run-game__linescore-winner':
                            line_scores.game_winner !== 'H'
                        }"
                        class="flex flex-align-center"
                      >
                        <img
                          :src="
                            `${
                              line_scores.this_team_is_home_team
                                ? $root.absolutize_cdn(game.opponent.image.url)
                                : $root.school_logo()
                            }?width=48&height=48`
                          "
                          class="sidearm-mm-run-game__linescore-logo px-1 py-2"
                        />
                        <span
                          class="sidearm-mm-run-game__linescore-team text-left"
                          >{{
                            line_scores.this_team_is_home_team
                              ? this.$root.shorten_name(game.opponent.title)
                              : $root.data.school.name
                          }}</span
                        >
                      </div>
                    </th>
                    <td
                      v-for="(score, index) in line_scores.period_home_score"
                      :key="index"
                      :class="{
                        'border-light-l text-bold':
                          index === line_scores.period_home_score.length - 1
                      }"
                      class="px-05"
                    >
                      {{ score }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="border-light-t text-normal ">
                      <div
                        :class="{
                          'sidearm-mm-run-game__linescore-winner':
                            line_scores.game_winner === 'H'
                        }"
                        class="flex flex-align-center"
                      >
                        <img
                          :src="
                            `${
                              !line_scores.this_team_is_home_team
                                ? $root.absolutize_cdn(game.opponent.image.url)
                                : $root.school_logo()
                            }?width=48&height=48`
                          "
                          class="sidearm-mm-run-game__linescore-logo px-1 py-2"
                        />
                        <span
                          class="sidearm-mm-run-game__linescore-team text-left"
                          >{{
                            !line_scores.this_team_is_home_team
                              ? $root.shorten_name(game.opponent.title)
                              : $root.data.school.name
                          }}</span
                        >
                      </div>
                    </th>
                    <td
                      v-for="(score, index) in line_scores.period_away_score"
                      :key="index"
                      :class="{
                        'border-light-l text-bold':
                          index === line_scores.period_away_score.length - 1
                      }"
                      class="px-05 border-light-t"
                    >
                      {{ score }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                class="sidearm-mm-run-game__links flex flex-align-center pt-1"
              >
                <a
                  v-if="game.result.boxscore && game.result.boxscore"
                  :href="game.result.boxscore"
                  target="_blank"
                  class="sidearm-mm-btn --primary mr-2"
                  >Box Score</a
                >
                <a
                  v-if="game.story && game.story.url"
                  :href="game.story.url"
                  target="_blank"
                  class="sidearm-mm-btn --primary mr-2"
                  >Recap</a
                >
                <div
                  v-if="game.media && game.media.video"
                  class="flex flex-align-center py-1"
                >
                  <!-- TODO-KL -->
                  <modal-video v-if="false" video="ScMzIvxBSi4">
                    <button
                      slot-scope="scope"
                      type="button"
                      @click="scope.open"
                      class="sidearm-mm-play-btn"
                      aria-label="Watch Highlight"
                    >
                      <icon>sf-play-minimal</icon>
                    </button>
                  </modal-video>
                  <!-- TODO-KL -->
                  <!-- <div class="type-paragraph mx-1">Watch Highlights</div> -->
                  <div
                    class="flex flex-align-center"
                    @click="goto(game.media.video, true)"
                  >
                    <!-- TODO-KL modal-video element? -->
                    <button
                      type="button"
                      class="sidearm-mm-play-btn"
                      aria-label="Watch Highlights"
                    >
                      <icon>sf-play-minimal</icon>
                    </button>
                    <div class="type-paragraph mx-1">
                      {{ this.game.media.video_text || "Watch Highlights" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="top_performers && top_performers.length > 0"
            class="sidearm-mm-run-game__stats sidearm-mm-run-game__body-column"
          >
            <h4 class="type-heading-small-plain">Top Performers</h4>
            <table
              class="sidearm-mm-run-game__stats-table w-100"
              cellspacing="0"
            >
              <caption class="hide">
                Athlete Stats
              </caption>
              <thead>
                <tr class="text-bold">
                  <th scope="col" class="">
                    <span class="accessible-hide">Athlete</span>
                  </th>
                  <th scope="col" class="py-1 text-uppercase">Pts</th>
                  <th scope="col" class="py-1 text-uppercase">Reb</th>
                  <th scope="col" class="py-1 text-uppercase">Ast</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  v-for="player in top_performers"
                  :key="player.rp_id"
                >
                  <td
                    class=" flex flex-align-center text-left text-bold border-light-t py-1"
                  >
                    <span class="sidearm-mm-run-game__stats-headshot">
                      <img
                        :src="
                          player && player.image && player.image.url
                            ? $root.absolutize_cdn(player.image.url) +
                              '?width=48&height=48&mode=crop&anchor=topcenter'
                            : $root.school_logo(48, 48)
                        "
                        :alt="player.name"
                      />
                    </span>
                    <span class="text-left">{{ player.name }}</span>
                  </td>
                  <td class="border-light-t">
                    {{ player.stats.stats.total_points_scored }}
                  </td>
                  <td class="border-light-t">
                    {{ player.stats.stats.total_rebounds }}
                  </td>
                  <td class="border-light-t">
                    {{ player.stats.stats.assists }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "RunGamePrevious",
  props: {
    round: { type: Object, required: true }
  },

  data: () => ({
    is_open: false,
    players_stats: [],
    players_with_stats: [],
    top_performers: []
  }),

  computed: {
    game() {
      if (!this.round) {
        return null;
      }
      return this.round.game;
    },
    line_scores() {
      if (this.game && this.game.result && this.game.result.result_json) {
        try {
          return JSON.parse(this.game.result.result_json);
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    has_both_seeds() {
      return (
        this.$root.data.team.seed &&
        this.game.opponent && 
        this.game.opponent.seed &&
        +this.game.opponent.seed <= 16
      );
    }
  },

  methods: {
    toggle_accordion(value) {
      if (value !== undefined) {
        this.is_open = !!value;
      } else {
        this.is_open = !this.is_open;
      }
      //600ms because the accordion transition is 500ms
      setTimeout(() => {
        this.reBuild();

        var resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      }, 600);
    },
    beforeEnter: function(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    leave: function(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    shortened_round_name(round) {
      if (!round) return "";
      return round.match(/\d/g).join("");
    },
    get_boxscore() {
      return fetch(`/services/boxscore.ashx?bid=${this.game.bid}`)
        .then(response => response.json())
        .then(response => {
          return response.data;
        })
        .catch(err => {
          console.warn("Failed to load boxscore", err);
          return null;
        });
    },
    get_player_performances(boxscore) {
      const our_players = boxscore.this_team.players;
      this.players_stats = our_players.map(x => {
        return {
          ...x,
          performance_index: this.calculate_player_performance(x)
        };
      });
    },
    combine_players_with_stats() {
      if (!this.$root.data.roster || !this.players_stats) {
        return [];
      }

      let roster_without_stats = this.$root.data.roster.slice();
      let stats_players = this.players_stats.slice();

      let roster_combined = JSON.parse(
        JSON.stringify(roster_without_stats)
      ).map(player => {
        let stat_player_index = stats_players.findIndex(
          stats => parseInt(stats.roster_player_id) === player.rp_id
        );
        let matched_stats = null;
        if (stat_player_index > -1) {
          matched_stats = stats_players.splice(stat_player_index, 1)[0];
        }
        player.stats = matched_stats;
        return player;
      });
      return roster_combined;
    },
    calculate_player_performance(player) {
      const to_num = stat => {
        return parseFloat(stat) || 0;
      };
      const stats = player.stats;
      // (Points + Rebounds + Assists + Steals + Blocks + Fouls Drawn) - (Missed Field Goals + Missed Free Throws + Turnovers + Shots Rejected + Fouls Committed).
      if (!stats) {
        return 0;
      }
      const performance_index =
        to_num(stats.total_points_scored) +
        to_num(stats.total_rebounds) +
        to_num(stats.assists) +
        to_num(stats.steals) +
        to_num(stats.blocked_shots) -
        to_num(stats.turnovers);
      return performance_index;
    },
    to_num(stat) {
      return parseFloat(stat) || 0;
    },
    get_top_performers() {
      const result = this.players_with_stats
        .slice()
        .filter(x => {
          return x && x.stats && x.stats.stats;
        })
        .sort((a, b) => {
          if (a.stats.performance_index === b.stats.performance_index) {
            return 0;
          }
          return a.stats.performance_index > b.stats.performance_index ? 1 : -1;
        })
        .reverse()
        .slice(0, 3);
      this.top_performers = result;
    }
  },
  mounted() {
    this.get_boxscore().then(boxscore => {
      if (boxscore === null) {
        return;
      }
      this.get_player_performances(boxscore);
      this.players_with_stats = this.combine_players_with_stats();
      this.get_top_performers();
    });
  }
};
</script>

<style lang="scss" scoped>
.accessible-hide {
  position: absolute;
  left: -9999px;
  top: -9999px;
}
.sidearm-mm-play-btn {
  @include play-btn(3.75rem, $color-black);
}
.#{$prefix}-run-game {
  &__header {
    flex-wrap: wrap;
  }
  &__round {
    width: 100%;
    @include flex-item(0 1 auto);
  }
  &__team {
    width: 25%;
    @include flex-item(0 1 auto);
  }
  &__button-container {
    width: 100%;
    @include flex-item(0 1 auto);
  }
  &__result {
    width: 50%;
    @include flex-item(0 1 auto);
  }
  &__team-seed {
    @include flex-item(0 0 auto);
    min-width: 48px;
    text-align: center;
  }
  &__button {
    @include base-reset();
    width: 100%;
    height: 100%;
  }
  &__score {
    color: $text-on-light;
    span::after {
      background-color: $text-on-light;
      height: 2px;
    }
  }
  &__score--winner {
    color: $color-black;
    span::before {
      position: absolute;
      top: 50%;
      left: 100%;
      content: "\e009";
      font-family: $font-icons;
      font-size: 1rem;
      padding: 0 $spacer * 2;
      transform: translate(0, -50%);
      color: $color-success;
    }
    &.sidearm-mm-run-game__score--left {
      span::before {
        left: auto;
        right: 100%;
        content: "\e010";
      }
    }
  }
  &__body {
    overflow: auto;
    transition: 0.5s;
  }
  &__body-inner {
    border-top: none;
    padding-top: 48px;
    flex-direction: column;
  }
  &__body-column {
    width: 100%;
    @include flex-item(0 0 auto);
    padding: 0 12px;
  }
  &__stats-headshot {
    display: inline-block;
    width: 72px;
    height: 72px;
    border: dashed 1px $stroke-on-light;
    border-radius: 50%;
    padding: 12px;
    margin-right: 48px;
    position: relative;
    img {
      vertical-align: middle;
      border-radius: 50%;
      object-fit: cover;
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 100%;
      height: 1px;
      width: 24px;
      content: "";
      border-top: dashed 1px $stroke-on-light;
    }
  }
  &__video-modal {
    @include hide();

    background-color: rgba($color-black, 0.8);

    &.is-toggled {
      @include unhide();
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 101;
    }
  }
  &__links {
    flex-wrap: wrap;
  }
  &__team-logo-container {
    width: 100%;
    max-width: 96px;
  }
  &__team-logo {
    width: 100%;
    position: relative;
    padding-bottom: 100%;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__video-modal-player-container {
    padding-bottom: 56.25%;
  }

  &__video-modal-player {
    left: 0;
    top: 0;
  }

  &__video-modal-close {
    @include base-reset();
    color: $color-white;
  }

  @media screen and (min-width: 1028px) {
    width: 75%;
    margin-left: 12.5%;

    &__team,
    &__button-container,
    &__round {
      width: 16.6667%;
    }
    &__result {
      width: 33.333%;
    }
    &__body {
      overflow: hidden;
    }
    &__body-inner {
      flex-direction: row;
      padding-top: 0;
    }
    &__body-column {
      width: 50%;
      padding: #{grid_percent(60)};
    }
  }
}
</style>
